/** @deprecated Use `useCurrentTabControls()` instead. */
export const CURRENT_TAB_CONTROLS_DOM_ATTRIBUTE = '@creditinfo-ui/tabs/currentTabControls';

export const TAB_BUTTON_PADDING_BOTTOM = 15;
